import { render, staticRenderFns } from "./Tramites.vue?vue&type=template&id=e7ea0f30&scoped=true&"
import script from "./Tramites.vue?vue&type=script&lang=js&"
export * from "./Tramites.vue?vue&type=script&lang=js&"
import style0 from "./Tramites.vue?vue&type=style&index=0&id=e7ea0f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ea0f30",
  null
  
)

export default component.exports